/**
 * Appends query parameters to a path, dropping only the ones that are actually
 * absent (null / undefined).
 *
 * The list endpoints used to interpolate straight into a template string, so an
 * unset filter was serialised as the literal text "undefined":
 *
 *     /users?role=User&q=&take=2&page=&status=undefined
 *
 * The API then had to interpret the string "undefined" as a status.
 *
 * Empty strings are deliberately KEPT. Several endpoints treat `q=` as
 * "match everything" — the search filter builds a regex as `^(${q})`, so an
 * empty value yields `^()` (matches all) while a missing value yields
 * `^(undefined)` (matches nothing). Dropping `q` therefore emptied the Finance
 * and Visits lists. Sending `q=` preserves that contract.
 */
export const withQuery = (
  path: string,
  params: Record<string, unknown>,
): string => {
  const search = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    search.append(key, String(value));
  });

  const qs = search.toString();
  if (!qs) return path;

  return `${path}${path.includes('?') ? '&' : '?'}${qs}`;
};
